import SortListOptionsEnum from '../enums/SortListOptionsEnum.js';
import type ISortListLocalizedInformation from '../types/ISortListLocalizedInformation.js';
import type ISortListTranslations from '../types/ISortListTranslations.js';

export default class LabelUtility {
	/**
	 * Get label for button or sort list option.
	 *
	 * @param option The option.
	 * @param localizedInformationOrTranslations The localized information or translations object.
	 * @returns Current label for button.
	 */
	public static getLabel(
		option: SortListOptionsEnum | null,
		localizedInformationOrTranslations: ISortListLocalizedInformation | ISortListTranslations
	): string {
		const translations =
			'translations' in localizedInformationOrTranslations
				? localizedInformationOrTranslations.translations
				: localizedInformationOrTranslations;
		switch (option) {
			case SortListOptionsEnum.aisleLocation:
				return translations.pickingListSortAisleLocation;
			case SortListOptionsEnum.packageSize:
				return translations.pickingListSortPackageSize;
			case SortListOptionsEnum.packageWeight:
				return translations.pickingListSortPackageWeight;
			case SortListOptionsEnum.default:
				return translations.pickingListSortDefault;
			default:
				return translations.pickingListSortTitle;
		}
	}
}
